
import React from "react";

function CustomInput({
    type = "text",
    value,
    onChange,
    name,
    placeholder,
    className = "form-control",
    maxLength,
    required = false,
    disabled = false
}) {

    // Input validation rules
    const handleChange = (e) => {

        let val = e.target.value;

        switch (type) {

            // Numbers only
            case "number":
                val = val.replace(/[^0-9]/g, "");
                break;

            // Decimal numbers
            case "decimal":
                val = val.replace(/[^0-9.]/g, "");

                // Allow only one decimal point
                const decimalParts = val.split(".");
                if (decimalParts.length > 2) {
                    val = decimalParts[0] + "." + decimalParts.slice(1).join("");
                }
                break;

            // Amount (2 decimal places)
            case "amount":
                val = val.replace(/[^0-9.]/g, "");

                const amountParts = val.split(".");

                if (amountParts.length > 2) {
                    val = amountParts[0] + "." + amountParts.slice(1).join("");
                }

                if (amountParts[1]?.length > 2) {
                    val = amountParts[0] + "." + amountParts[1].slice(0, 2);
                }
                break;

            // Alphabet only
            case "alphabet":
                val = val.replace(/[^a-zA-Z\s]/g, "");
                break;

            // Alphanumeric
            case "alphanumeric":
                val = val.replace(/[^a-zA-Z0-9]/g, "");
                break;

            // Mobile number
            case "mobile":
                val = val.replace(/[^0-9]/g, "").slice(0, 10);
                break;

            // No special characters
            case "nospecial":
                val = val.replace(/[^a-zA-Z0-9\s]/g, "");
                break;

            default:
                break;
        }

        if (maxLength) {
            val = val.slice(0, maxLength);
        }

        onChange({
            ...e,
            target: {
                ...e.target,
                name,
                value: val
            }
        });
    };

    return (
        <input
            type="text"
            name={name}
            value={value ?? ""}
            onChange={handleChange}
            placeholder={placeholder}
            className={className}
            required={required}
            disabled={disabled}
            autoComplete="off"
        />
    );
}

export default CustomInput;
